import type { ListBuilderList } from '../../../types';
import { createVehicleColumns } from '../columns';

/**
 * On Route vehicles list configuration
 * Shows vehicles currently assigned to active routes
 */
export const onRouteVehiclesList: ListBuilderList = {
	id: 'default-vehicles-on-route',
	name: 'On Route',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		vehicleRouteStatus: {
			defaultValue: [{ id: 'in-progress', label: 'In Progress' }],
		},
	},
	columns: createVehicleColumns(),
	defaultSortId: 'vehicle-name',
	sortOrder: 1,
};
